// src/components/About/index.js
import React, { Component } from 'react';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import BaseService from '../../service/baseservice';

export default class UserSelectField extends Component {
  handleUserChanged = (request, index) => {
    var selectedUser = null;

    var startIndex = this.props.showNoSellerItem ? 2 : 1;
    var state = this.state;
    if (index >= startIndex) {
      selectedUser = BaseService.fetchedData.users[index-startIndex];
    }

    if (this.props.showNoSellerItem && index == 1 && this.props.onAllUsersSelected) {
      this.props.onAllUsersSelected();
    } else if (this.props.onUserSelected) {
      this.props.onUserSelected(selectedUser);
    }
  }

  render() {
    var userItems = BaseService.fetchedData.users.map(user => {
      return <MenuItem key={user._id} value={user._id} primaryText={user.fullName} />
    });

    var noSellerItem = this.props.showNoSellerItem ? <MenuItem key={"NO_SELLER"} value={"NO_SELLER"} primaryText="Ilman myyjää" /> : null;

    return <SelectField
              floatingLabelText={this.props.floatingLabelText}
              onChange={this.handleUserChanged}
              value={this.props.value}
              style={this.props.style}
              errorText={this.props.errorText}
              errorStyle={this.props.errorStyle}>
              <MenuItem value={null} primaryText={this.props.emptyText ? this.props.emptyText : ""} />
                  {noSellerItem}
                  {userItems}
            </SelectField>
  }
}



// WEBPACK FOOTER //
// ./src/components/shared/UserSelectField.js